module.exports = __webpack_public_path__ + "img/exterior_2.e8ae1aa4.jpg";